<template>
  <a-modal
      :title="title"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="confirmLoading"
      :width="680"
  >
    <div class="modal-content">
      <!-- 订单数量及列表 -->
      <div class="order-count">
        <span class="count-label">{{ $t('dashboard.order.selectedOrderQuantity') }}：</span>
        <a-tag color="blue">{{ selectedCount }}个</a-tag>
      </div>

      <div class="order-tags">
        <a-tag
            v-for="(row, index) in selectedRows"
            :key="index"
            color="orange"
            class="order-tag"
        >
          {{ row.waybillNumber }}
        </a-tag>
      </div>

      <!-- 表单区域 -->
      <div class="form-section">
        <a-form :form="form" layout="horizontal">
          <!-- 新单号 -->
          <a-form-item :label="$t('dashboard.order.newOrderNumber')" :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }" :colon="false" class="form-item">
            <a-input
                v-decorator="[
                'newBarCodeNo',
                { rules: [{ required: true, message: this.$t('dashboard.order.placeholderNewOrderNumber') }] }
              ]"
                :placeholder="$t('dashboard.order.placeholderNewOrderNumber')"
                class="form-input"
            />
          </a-form-item>

          <!-- 运输类型 -->
          <a-form-item :label="$t('dashboard.order.transportType')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" :colon="false"
                       class="form-item">
            <a-select
                v-decorator="[
                'settleQuickType',
                { rules: [{ required: true, message: this.$t('dashboard.order.placeholderTransportType') }] }
              ]"
                :placeholder="$t('dashboard.order.placeholderTransportType')"
                class="form-select"
            >
              <a-select-option value="UZ-PUDO-3">UZ-PUDO-3</a-select-option>
              <a-select-option value="UZ-PUDO-COD-3">UZ-PUDO-COD-3</a-select-option>
              <!--              <a-select-option value="UZ-AIR-PUDO-3">UZ-AIR-PUDO-3</a-select-option>-->
              <!--              <a-select-option value="UZ-RD-PUDO-3">UZ-RD-PUDO-3</a-select-option>-->
              <!--              <a-select-option value="UZ-AIR-PUDO-COD-3">UZ-AIR-PUDO-COD-3</a-select-option>-->
              <!--              <a-select-option value="UZ-RD-PUDO-COD-3">UZ-RD-PUDO-COD-3</a-select-option>-->
            </a-select>
          </a-form-item>
        </a-form>
      </div>

      <!-- 错误提示 -->
      <a-alert
          v-if="errorMessage"
          :message="errorMessage"
          type="error"
          show-icon
          class="error-alert"
      />
    </div>
  </a-modal>
</template>

<script>
import {updateOrderBarCodeNo} from 'api/app'
import {message} from 'ant-design-vue';

export default {
  name: 'ModifyOrderNumberModal',
  props: {
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: this.$t('antd.table.modifyOrderNumber'),
      visible: false,
      confirmLoading: false,
      errorMessage: '',
      form: this.$form.createForm(this),
    }
  },
  computed: {
    selectedCount() {
      return this.selectedRows.length
    }
  },
  methods: {
    // onChange(value) {
    //   // 每次切换时先清空错误信息
    //   this.errorMessage = ''
    //
    //   // 获取表单当前值
    //   const formValues = this.form.getFieldsValue()
    //   const newType = value || formValues.settleQuickType || ''
    //
    //   // 如果还没有选择新类型，则不校验
    //   if (!newType) return
    //
    //   // 校验运输方式是否改变
    //   const transportTypeChanged = this.selectedRows.some(row => {
    //     const oldType = row.productCode || ''
    //
    //     // 检查运输方式是否从RD变为AIR或反之
    //     return ((oldType.includes('RD') && newType.includes('AIR')) ||
    //         (oldType.includes('AIR') && newType.includes('RD')))
    //   })
    //
    //   if (transportTypeChanged) {
    //     this.errorMessage = '运输方式(RD/AIR)不允许变动，请选择与原始订单相同的运输方式'
    //   }
    // },
    openModal() {
      this.visible = true
      this.errorMessage = ''
      this.form.resetFields()
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 校验订单状态
          const invalidOrders = this.selectedRows.filter(
              row => row.orderStatus == 2 || row.orderStatus == 3
          )

          if (invalidOrders.length > 0) {

            // this.errorMessage = `选中的订单中包含已签收或异常订单(单号: ${invalidOrders[0].barCodeNo})，不允许修改单号`
            this.errorMessage = this.$t('dashboard.order.differentStatesNotAllowedModified', {
              barcodeNo: invalidOrders[0].waybillNumber
            });
            return
          }

          // 校验运输方式是否改变
          // const transportTypeChanged = this.selectedRows.some(row => {
          //   const oldType = row.productCode || ''
          //   const newType = values.settleQuickType || ''
          //
          //   // 检查运输方式是否从RD变为AIR或反之
          //   return (oldType != null || oldType !=='') && ((oldType.includes('RD') && newType.includes('AIR')) ||
          //       (oldType.includes('AIR') && newType.includes('RD')))
          // })
          //
          // if (transportTypeChanged) {
          //   this.errorMessage = '运输方式(RD/AIR)不允许变动，请选择与原始订单相同的运输方式'
          //   return
          // }

          // 收集所有不同的身份证号码
          const uniqueIdCardNos = [...new Set(this.selectedRows.map(row => row.toCustIdCardNo))];
          if (uniqueIdCardNos.length > 1) {
            // this.$message.error(`所选订单包含多个不同的身份证号码：${uniqueIdCardNos.join('、')}，请确保选择同一个人的订单`);
            this.errorMessage = this.$t('dashboard.order.multiplePassportNumbers', {
              idCard: uniqueIdCardNos.join('、')
            });
            return
          }

          this.confirmLoading = true

          // 这里调用API提交修改
          const params = {
            barCodeNos: this.selectedRows.map(row => row.waybillNumber),
            wcBarCodeNo: values.newBarCodeNo,
            settleQuickType: values.settleQuickType
          }

          updateOrderBarCodeNo(params).then(res => {
            if (res.code === 200) {
              message.success(this.$t('dashboard.order.updatedSuccess'))
              this.visible = false
              this.$emit('refresh') // 触发父组件的refresh事件
              this.$emit('clear-selection') // 新增：触发清空选择
            } else {
              message.error(res.msg || this.$t('dashboard.order.updateFailed'))
              this.visible = false
            }
          }).catch(error => {
            message.error(error.message || '请求失败')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.modal-content {
  padding: 16px 24px;
}

.order-count {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.count-label {
  font-weight: 500;
  margin-right: 8px;
}

.order-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
  background: #fafafa;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.order-tag {
  font-family: monospace;
  padding: 0 8px;
  height: 28px;
  line-height: 28px;
}

.form-section {
  margin-top: 16px;
}

.form-item {
  margin-bottom: 16px;
}

.form-item >>> .ant-form-item-label {
  width: 80px;
  text-align: right;
  padding-right: 12px;
}

.form-item >>> .ant-form-item-control {
  width: calc(100% - 80px);
}

.form-input,
.form-select {
  width: 100%;
  max-width: 400px;
}

.error-alert {
  margin-top: 16px;
  width: calc(100% - 80px);
}
</style>
